/**
 * Helepr to make highlight syntax in VS Code
 * It accepts a string and returns the same string interpolated
 * @param {*} literals
 * @param  {...any} expressions
 */
export default (literals, ...expressions) => {
	let string = ``
	for (const [i, val] of expressions.entries()) {
		string += literals[i] + val
	}
	string += literals[literals.length - 1]
	return string
}
